import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, NavParams, ModalController, LoadingController, ToastController, AlertController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BuscarPessoaPage } from '../../buscar-pessoa/buscar-pessoa.page';
import { FormGeradorPage } from '../../form-gerador/form-gerador.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { UserProvider } from 'src/app/services/user/user';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ImagePipe } from 'src/app/pipes/image/image';
import { InstituicaoProvider } from 'src/app/services/instituicao/instituicao';

@Component({
  selector: 'app-grupo-gerenciar-visitantes-add',
  templateUrl: './grupo-gerenciar-visitantes-add.page.html',
  styleUrls: ['./grupo-gerenciar-visitantes-add.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ImagePipe,
    TranslateModule
  ],
})
export class GrupoGerenciarVisitantesAddPage implements OnInit {
  pessoa: any = {};
  visitante: any = {};
  idGrupo: any;
  loader = this.loadingController.create({
    message: this.translate.instant("Carregando")
  });
  visitantes: any = [];
  exibirFiltroMembrosTodasFiliais = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public grupoProvider: GrupoProvider,
    public loadingController: LoadingController,
    public toastCtrl: ToastController,
    private translate: TranslateService,
    public userProvider: UserProvider,
    public alertCtrl: AlertController,
    public instituicaoProvider: InstituicaoProvider,
  ) {
    this.idGrupo = navParams.get('idGrupo');

    this.instituicaoProvider.hasConfigSede('218').subscribe(data => {
      this.exibirFiltroMembrosTodasFiliais = data;
    });

    if (this.navParams.get('solicitacaoParticipante')) {
      this.pessoa = this.navParams.get('solicitacaoParticipante');
      this.visitante.idPessoa = this.pessoa.id;
      this.criar();
    }
  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss(this.visitantes.length > 0 ? this.visitantes : false);
  }

  public async selecionarPessoa(): Promise<string> {
    const dataPessoa = { isVisitante: true, exibirFiltroMembrosTodasFiliais: this.exibirFiltroMembrosTodasFiliais, adiciona: true };
    const modalPessoa = await this.modalCtrl.create({ component: BuscarPessoaPage, componentProps: dataPessoa });
    modalPessoa.present();

    const visitante = await modalPessoa.onWillDismiss();
    if (visitante.data && visitante.data.pessoa) {
      this.pessoa = visitante.data.pessoa;
      this.visitante.idPessoa = this.pessoa.id;
      this.criar();
    }

    return '';
  }

  salvar(id: any) {
    this.visitante.idPessoa = id;
    this.criar();
  }

  async criarVisitante() {
    this.userProvider.getDados().then(async result => {
      var cadastro: any = {};
      cadastro.form = 'APP_GRU_VISIT';
      cadastro.idPessoaTipo = 5;
      cadastro.titulo = this.translate.instant('Adicionar Visitante');
      cadastro.idInstituicao = result.instituicao.id;

      var modalPessoa = await this.modalCtrl.create({ component: FormGeradorPage, componentProps: cadastro });
      modalPessoa.present();

      const pessoa = (await modalPessoa.onWillDismiss())

      if (pessoa.data) {
        this.pessoa = pessoa.data;
        this.visitante.idPessoa = this.pessoa.id;
        this.criar();
      }
    });
  }

  criar() {
    this.grupoProvider.criarVisitante(this.idGrupo, this.visitante).subscribe(async data => {
      if (data.status !== false) {
        this.grupoProvider.getVisitantesGrupo(this.idGrupo).subscribe(async d => {
          const toast = await this.toastCtrl.create({
            message: this.translate.instant('Visitante adicionado com sucesso!'),
            duration: 3000
          });

          toast.present();

          this.visitantes = d;
          this.modalCtrl.dismiss(this.visitantes);
        });

      } else {
        const confirmAlert = await this.alertCtrl.create({
          cssClass: "alerta-personalizado",
          mode: "ios",
          header: this.translate.instant('Atenção'),
          message: this.translate.instant(data.message),
          buttons: [
            {
              text: this.translate.instant('Ok'),
              role: 'cancel',
            }
          ],
        });
        confirmAlert.present();
      }
    });
  }
}
